import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddCourse = () => {
  const [formValues, setFormValues] = useState({
    department_id: "",
    courseCategory_id: "",
    coursename: "",
    duration: "",
    fees: "",
    seasonal_discount: "",
    brief: "",
    slug: "",
    original_price: "",
    subscription_features: [],
  });

  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const navigate = useNavigate();
  const [newFeature, setNewFeature] = useState("");
  const [formError, setFormError] = useState("");
  // for img and video
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [videoPreviewUrl, setVideoPreviewUrl] = useState("");
  const [courseImage, setCourseImage] = useState(null);
  const [courseVideo, setCourseVideo] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    const fetchdepartment = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setDepartments(response.data.data);
        // console.log(response.data.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchdepartment();
  }, []);

  useEffect(() => {
    const fetchCourseCategory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${formValues?.department_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourseCategories(response?.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourseCategory();
  }, [formValues?.department_id]);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (isSaving) return; // Prevent multiple submissions
 
    try {
      

      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      // Validate if at least one membership feature is added
      if (formValues.subscription_features.length === 0) {
        setLoading(false);
        setSnackbarMessage("Skill required! Please add at least one before saving.");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
        return;
      }
      
      setIsSaving(true);
      setLoading(true);

      // Create FormData object
      const formData = new FormData();
      formData.append("department_id", formValues.department_id);
      formData.append("courseCategory_id", formValues.courseCategory_id);
      formData.append("coursename", formValues.coursename);
      formData.append("seasonal_discount", formValues.seasonal_discount);
      formData.append("duration", formValues.duration);
      formData.append("fees", formValues.fees);
      formData.append("price", formValues.price);
      formData.append("brief", formValues.brief);
      formData.append(
        "subscription_features",
        JSON.stringify(formValues.subscription_features)
      );

      if (courseImage) formData.append("courseImage", courseImage);
      if (courseVideo) formData.append("courseVideo", courseVideo);

      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-course`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
          "Content-Type": "multipart/form-data",
        }
      );
      if (response.status === 201) {
        
        setSnackbarMessage("Created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/courses-list");
        }, 2000);
      }
    } catch (err) {
      setIsSaving(true);
      setLoading(true);
      // Check for 400 status error
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else if (err.response && err.response.status === 401) {
        setSnackbarMessage("This Course name is already exists. Please check and update accordingly.");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to create. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    }
  };

  const handleAddFeature = () => {
    if (newFeature?.trim() === "") {
      setFormError("Feature cannot be empty.");
      return;
    }

    if (formValues?.subscription_features?.includes(newFeature.trim())) {
      setFormError("Feature already added.");
      return;
    }

    setFormValues((prevState) => ({
      ...prevState,
      subscription_features: [
        ...(prevState.subscription_features || []), // Ensure it's an array
        newFeature.trim(),
      ],
    }));

    setNewFeature(""); // Clear the input field
    setFormError(""); // Clear the error message
  };

  const handleRemoveFeature = (featureToRemove) => {
    setFormValues({
      ...formValues,
      subscription_features: formValues?.subscription_features?.filter(
        (feature) => feature !== featureToRemove
      ),
    });
  };

  // for handle img and video
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setCourseImage(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

const handleVideoChange = (e) => {
  const file = e.target.files[0]; // Get the selected file

  // Clear previous preview URL and revoke object URL to prevent memory leaks
  if (videoPreviewUrl) {
    URL.revokeObjectURL(videoPreviewUrl);
  }

  if (file) {
    // Check file size (100 MB limit)
    const maxSize = 100 * 1024 * 1024; // 100 MB in bytes
    
    if (file.size > maxSize) {
      // Show error message (you can replace this with your preferred notification system)
      // alert('File size exceeds the 100 MB limit. Please choose a smaller file.');
      setSnackbarMessage("File size exceeds the 100 MB limit");
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      // Clear the input and state
      e.target.value = '';
      setVideoPreviewUrl("");
      setCourseVideo(null);
      return;
    }

    // Create a new preview URL for the selected video
    const url = URL.createObjectURL(file);
    setVideoPreviewUrl(url);
    setCourseVideo(file); // Set the video file for upload
  } else {
    // Clear the preview and course video if no file is selected
    setVideoPreviewUrl("");
    setCourseVideo(null);
  }
};

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={(e) => handleFormSubmit(e)}>
              <div className="mb-20">
                <label
                  htmlFor="depart"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="depart"
                  value={formValues?.department_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      courseCategory_id: "",
                      department_id: e.target.value,
                    })
                  }
                  required
                >
                  <option value="" disabled>
                    Select a Department
                  </option>
                  {departments?.map((department) => (
                    <option key={department?._id} value={department?._id}>
                      {department?.department_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-20">
                <label
                  htmlFor="courseCategory"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Level
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="courseCategory"
                  value={formValues?.courseCategory_id}
                  required
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      courseCategory_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a Level
                  </option>
                  {courseCategories?.map((courseCategory) => (
                    <option
                      key={courseCategory?._id}
                      value={courseCategory?._id}
                    >
                      {courseCategory?.courseCategoryName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Course Name */}
              <div className="mb-20">
                <label
                  htmlFor="coursename"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Course Name
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  required
                  type="text"
                  id="coursename"
                  placeholder="Enter course name"
                  className="form-control radius-8"
                  value={formValues?.coursename}
                  onChange={(e) =>
                    {
                      const value = e.target.value;
                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                      ...formValues,
                      coursename: e.target.value,
                    })}}
                  }
                />
              </div>

              {/* Duration */}
              <div className="mb-20">
                <label
                  htmlFor="duration"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Duration (In Weeks)
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="number"
                  id="duration"
                  placeholder="Enter course duration"
                  className="form-control radius-8"
                  min="0"
                  value={formValues?.duration}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      duration: e.target.value,
                    })
                  }
                  required
                />
              </div>

              {/* Fees */}
              <div className="mb-20">
                <label
                  htmlFor="fees"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Fees
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="number"
                  id="fees"
                  min={0}
                  placeholder="Enter fees"
                  className="form-control radius-8"
                  value={formValues.fees}
                  onChange={(e) =>
                    setFormValues({ ...formValues, fees: e.target.value })
                  }
                  onWheel={(e) => e.target.blur()}
                  required
                />
              </div>
              <div className="mb-20">
                <label
                  htmlFor="fees"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Price
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="number"
                  id="price"
                  min={0}
                  placeholder="Enter price"
                  className="form-control radius-8"
                  value={formValues.price}
                  onChange={(e) =>
                    setFormValues({ ...formValues, price: e.target.value })
                  }
                  onWheel={(e) => e.target.blur()}
                  required
                />
              </div>

              {/* seasonal_discount */}
              <div className="mb-20">
                <label
                  htmlFor="seasonal_discount"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Seasonal Discount(%)
                </label>
                <input
                  type="number"
                  placeholder="Enter seasonal discount (optional)"
                  id="seasonal_discount"
                  className="form-control radius-8"
                  value={formValues.seasonal_discount}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      seasonal_discount: e.target.value,
                    })
                  }
                />
              </div>

              {/* Brief */}
              <div className="mb-20">
                <label
                  htmlFor="brief"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Brief
                  <span className="text-danger-600">*</span>
                </label>
                <textarea
                  id="brief"
                  placeholder="Enter brief description"
                  className="form-control radius-8"
                  value={formValues.brief}
                  onChange={(e) =>{
                    const value = e.target.value;
                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues, brief: e.target.value  });
                      }
                    }}
                  required
                />
              </div>

              <div className="mb-20">
                <label
                  htmlFor="courseImage"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Course Image
                </label>
                <div className="upload-field">
                  <input
                    type="file"
                    id="courseImage"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="d-none"
                  />
                  {/* Buttons container */}
                  <div className="d-flex gap-2 mb-2">
                    <button
                      type="button"
                      onClick={() =>
                        document.getElementById("courseImage").click()
                      }
                      className="btn btn-outline-primary"
                    >
                      <i className="fas fa-upload me-2"></i>
                      Upload Image
                    </button>

                    {/* {imagePreviewUrl && (
                      <button
                        type="button"
                        onClick={() => {
                          setImagePreviewUrl(null);
                          document.getElementById("courseImage").value = "";
                        }}
                        className="btn btn-outline-danger"
                      >
                        <i className="fas fa-trash me-2"></i>
                        Remove Image
                      </button>
                    )} */}
                  </div>
                  {imagePreviewUrl ? (
                    <div className="mt-2">
                      <img
                        src={imagePreviewUrl}
                        alt="Course Preview"
                        className="img-thumbnail"
                        style={{ maxHeight: "200px" }}
                      />
                    </div>
                  ) : (
                    <div className="text-muted small"></div>
                  )}
                </div>
              </div>

              <div className="mb-20">
                <label
                  htmlFor="courseVideo"
                  className="form-label fw-semibold text-primary-light text-sm mb-4"
                >
                  Course Video
                </label>
                <div className="upload-field">
                  {/* Info about max size */}
                  <div className="text-muted text-primary-light small mb-2">
                    Maximum file size: 100 MB
                  </div>
                  {/* Hidden file input */}
                  <input
                    type="file"
                    id="courseVideo"
                    accept="video/*"
                    onChange={handleVideoChange}
                    className="d-none"
                  />
                  {/* Buttons container */}
                  <div className="d-flex gap-2 mb-2">
                    <button
                      type="button"
                      onClick={() =>
                        document.getElementById("courseVideo").click()
                      }
                      className="btn btn-outline-primary"
                    >
                      <i className="fas fa-upload me-2"></i>
                      Upload Video
                    </button>
                    {/* ...existing code... */}
                  </div>
                  {videoPreviewUrl && (
                    <div className="mt-2">
                      <video
                        controls
                        className="w-100"
                        style={{ maxHeight: "200px" }}
                        src={videoPreviewUrl}
                      >
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  )}
                </div>
              </div>

              <div className="mb-24">
                <label
                  htmlFor="subscription_features"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Add Skills <span className="text-danger-600">*</span>
                </label>
                <input
                placeholder="Enter a skill"
                  className="form-control radius-8"
                  id="subscription_features"
                  value={newFeature}
                  onChange={(e) => setNewFeature(e.target.value)}
                />
                {formError && (
                  <div className="text-danger-600">{formError}</div>
                )}

                {/* Add Button */}
                <button
                  className="btn btn-outline-primary mt-2"
                  onClick={handleAddFeature}
                  disabled={loading || newFeature?.trim() === ""}
                >
                  +
                </button>

                {/* Display Added Features */}
                <div className="mt-3">
                  <p>Added Skills:</p>
                  <div className="d-flex flex-wrap">
                    {formValues?.subscription_features?.map(
                      (feature, index) => (
                        <div
                          key={index}
                          className="chip"
                          style={{
                            color: "black",
                            marginRight: "8px",
                            marginBottom: "8px",
                            backgroundColor: "#f0f0f0",
                            padding: "6px 12px",
                            borderRadius: "16px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span>{feature}</span>
                          <button
                            className="btn btn-sm btn-danger ml-2"
                            onClick={() => handleRemoveFeature(feature)}
                            style={{
                              borderRadius: "50%",
                              padding: "0 6px",
                              fontSize: "14px",
                            }}
                          >
                            x
                          </button>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/courses-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  disabled={isSaving || loading} // Ensure button is disabled
                >
                  {loading && "Save"}
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  {!loading && "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddCourse;
